import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router';

function redirectForLocalTest(toSubdomain, pathname, host) {
  let subList = host.split('.');

  let currentSubdomain =
    host.split('.')[1] && host.split('.')[1] !== 'com:3000'
      ? host.split('.')[0]
      : '';

  if (currentSubdomain === toSubdomain) {
    return pathname;
  } else {
    if (toSubdomain) {
      if (currentSubdomain) {
        subList.shift();
        return `http://${toSubdomain}.local-test-paylixecommerce.com:3000${pathname}`;
      } else {
        return `http://${toSubdomain}.local-test-paylixecommerce.com:3000${pathname}`;
      }
    } else {
      if (currentSubdomain) {
        subList.shift();
        return `http://local-test-paylixecommerce.com:3000${pathname}`;
      } else {
        return `http://local-test-paylixecommerce.com:3000${pathname}`;
      }
    }
  }
}

function redirectForStaging(toSubdomain, pathname, host) {
  let subList = host.split('.');
  let currentSubdomain = host.split('.')[1]
    ? host.split('.')[1] === 'io'
      ? ''
      : host.split('.')[0]
    : '';

  if (currentSubdomain === toSubdomain) {
    return pathname;
  } else {
    if (toSubdomain) {
      if (currentSubdomain) {
        subList.shift();
        return `https://${toSubdomain}.${subList.join('.')}${pathname}`;
      } else {
        return `https://${toSubdomain}.${subList.join('.')}${pathname}`;
      }
    } else {
      if (currentSubdomain) {
        subList.shift();
        return `https://${subList.join('.')}${pathname}`;
      } else {
        return `https://${subList.join('.')}${pathname}`;
      }
    }
  }
}

export function linkToSubdomain(toSubdomain, pathname) {
  let host = window && window.location ? window.location.host : '';

  let localTestpaylixecommerce = host.includes('local-test-paylixecommerce');
  let isStaging = host.includes('paylixecommerce.') || host.includes('-crispy.') || host.includes('-staging.');

  if (localTestpaylixecommerce) {
    return redirectForLocalTest(toSubdomain, pathname, host);
  } else if (isStaging) {
    return redirectForStaging(toSubdomain, pathname, host);
  }
}

export function getLinkToSubdomain(toSubdomain, pathname, isShopApp = false) {
  let { port, protocol, hostname } = window.location;

  let mainHostname = 'paylix.gg';
  if (hostname.includes('local-test-paylixecommerce.com')) {
    mainHostname = 'local-test-paylixecommerce.com';
    if (isShopApp) {
      port = '8080';
    }
  } else if (hostname.includes('paylixecommerce-staging.io')) {
    mainHostname = 'paylixecommerce-staging.io';
  } else if (isShopApp) {
    mainHostname = 'mypaylix.gg';
  } else if (hostname.includes('paylix.gg')) {
    mainHostname = 'paylix.gg';
  } else if (hostname.includes('paylixecommerce-crispy.io')) {
    mainHostname = 'paylixecommerce-crispy.io';
  }
  return `${protocol}//${toSubdomain ? (toSubdomain + '.') : ''}${mainHostname}${port ? (':' + port) : ''}${pathname ? (pathname[0] === '/' ? pathname : ('/' + pathname)) : ''}`;
}
